const NS = 'MmfsModulesDownloadPage';
const CLS = 'mmfsModulesDownloadPage';

import * as Api from '../../../../global/js/api';

export class MmfsModulesDownloadPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.getApi = this.$element.data('moduleApi');
		this.$itemsList = this.$element.find(`.tpl-content-list`);
		this.$printBtn = this.$element.find(`.printBtn`);
		this.$loading = this.$element.find(`#loading`);
		const urlParams = new URLSearchParams(window.location.search);
		const moduleId = urlParams.get('moduleId');
		this.params = {
			moduleId: moduleId
		};
		
		this.getItems();
	}

	getItems() {
		let url = this.getApi;
		if(!_.isEmpty(this.params)) {
            url += `?${$.param(this.params)}`;
        }
		this.$itemsList.empty();
		Api.getApi(url).then((data) => {
			let items = data.results;
			items.forEach((item, index) => {
				if (index > 0) {
					this.$itemsList.append('<div class="page-break"></div>');
				}
			
				this.$itemsList.append(`<h2>${item.Title}</h2>`);
				this.$itemsList.append(`<p>${item.Content}</p>`);
			});
			$('#loading').css('display','none');
		});
	}
}
